<div class="activities__title" *ngIf="items?.length">
  {{
    (total > 1 ? 'organizer.activities.total' : 'organizer.activity.total')
      | translate: { total }
  }}
</div>

<pagination-controls
  *ngIf="items?.length > itemsPerPage"
  (pageChange)="p = $event"
  previousLabel="Previous"
  directionLinks="false"
  nextLabel="Next"
  screenReaderPaginationLabel="Pagination"
  screenReaderPageLabel="page"
  screenReaderCurrentLabel="You're on page"
></pagination-controls>

<ul *ngIf="items?.length > 0" class="activities__list">
  <li
    *ngFor="
      let item of items
        | paginate: { itemsPerPage: itemsPerPage, currentPage: p };
      index as itemIndex
    "
  >
    <a [routerLink]="getPath(item) | localize" [attr.aria-label]="item.name">
      <!-- Activities results -->
      <app-attendee-activity-card
        [activity]="item"
      ></app-attendee-activity-card>
    </a>
  </li>
</ul>

<pagination-controls
  *ngIf="items?.length > itemsPerPage"
  (pageChange)="changePage($event)"
  previousLabel="Previous"
  directionLinks="false"
  nextLabel="Next"
  screenReaderPaginationLabel="Pagination"
  screenReaderPageLabel="page"
  screenReaderCurrentLabel="You're on page"
></pagination-controls>

<div
  class="activities__title activities__title--emtpy"
  *ngIf="items?.length === 0"
>
  {{ 'organizer.activities.no_results' | translate }}
</div>
